import { render, staticRenderFns } from "./AnimationCogOrb.vue?vue&type=template&id=1572977c&scoped=true&"
import script from "./AnimationCogOrb.vue?vue&type=script&lang=js&"
export * from "./AnimationCogOrb.vue?vue&type=script&lang=js&"
import style0 from "./AnimationCogOrb.vue?vue&type=style&index=0&id=1572977c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1572977c",
  null
  
)

export default component.exports